import React, { useEffect, useState } from "react";
import QuestionWrapper from "../components/microComponents/wrapper/QuestionWrapper";
import { appColors, month, questionTypes } from "../utils/constants";
import { toast } from "react-toastify";
import {
  getAllQuestions,
  getFarmerQuestion,
  getQuestionByOrder,
  submitAnswer,
} from "../api";
import QuestionLoadingSkeleton from "../components/microComponents/QuestionLoadingSkeleton";
import { formatAnswer } from "../utils";
import Tick from "../assets/svg/Tick";
import Celebrations from "./subComponents/Celebrations";

const Questionaire = () => {
  // const mockQuestions = checkboxQuestions;
  const [totalQuestions, setTotalQuestions] = React.useState(1);
  const [loading, setLoading] = React.useState(false);
  const [questionDetails, setQuestionDetails] = React.useState({
    questNumber: 1,
    question: "",
    answer: "",
    answeredBefore: false,
    surveyCompleted: false,
  });
  const [inputChanged, setInputChanged] = useState(false);
  // console.log("🚀 ~ Questionaire ~ questionDetails:", questionDetails)

  const updateQuestion = (question, hasDate = false) => {
    if (hasDate) {
      // Replace {month} and {year} with current month and year in the question
      const updatedQuestion = question?.replace("{month}", month[new Date().getMonth()]).replace("{year}", new Date().getFullYear());

      return updatedQuestion;
    }
    return question;
  };

  useEffect(() => {
    if (!loading) setLoading(true);

    // Get the total number of questions
    getAllQuestions()
      ?.then((data) => {
        setTotalQuestions(data?.total_questions);
      })
      .catch((error) => {
        console.error("🚀 ~ useEffect ~ error", error);
      });

    // Get the unanswered question
    // response should be {next_question: {question}, last_answer: {answer}, message}
    getFarmerQuestion()
      .then((data) => {
        console.log("🚀 ~ useEffect ~ getFarmerQuestion", data);
        if (data?.next_question) {
          setQuestionDetails({
            questNumber: data?.next_question?.order,
            question: { ...data?.next_question, question_text: updateQuestion(data?.next_question?.question_text, data?.next_question?.hasDate) },
          });
        } else if (!data?.next_question && data?.last_answer) {
          setQuestionDetails({
            ...questionDetails,
            surveyCompleted: true,
          });
        }
        //  if (data?.last_answer) {
        //    setLastQuestion(data?.last_answer);
        //  } else {
        //    setLastQuestion(null);
        //  }
      })
      .catch((error) => {
        console.error("🚀 ~ useEffect ~ error", error);
        // toast.error("Error fetching question. Please try again.");
      })
      .finally(() => {
        setLoading(false);
        setInputChanged(false);
      });
  }, []);

  // The function to get first question and next question
  const getQuestion = (valueUpdate = 0, prevNext = true) => {
    // console.log("🚀 ~ Questionaire ~ questionDetails:", questionDetails);

    setQuestionDetails({
      ...questionDetails,
      question: null,
      answer: "",
      answeredBefore: false,
    });
    getQuestionByOrder(prevNext ? questionDetails.questNumber + valueUpdate : valueUpdate === 0 ? 1 : valueUpdate)
      .then((data) => {
        console.log("🚀 ~ .then ~ data:", data);

        // TO DO: if answer

        setQuestionDetails({
          question: { ...data?.question, question_text: updateQuestion(data?.question?.question_text, data?.question?.hasDate) },
          questNumber: data?.question?.order,
          answer: data?.answer ? formatAnswer(data?.answer) : "",
          answeredBefore: data?.answer ? true : false,
        });
      })
      .catch((error) => {
        console.error("🚀 ~ useEffect ~ error", error);
        setQuestionDetails({
          ...questionDetails,
          question: "",
          answer: "",
          answeredBefore: false,
        });
        toast.error("Error fetching question. Please try again.");
      })
      .finally(() => {
        setLoading(false);
        setInputChanged(false);
      });
  };

  // Submit answer and get next question
  const handleNext = async () => {
    if (!loading) setLoading(true);

    let data = {
      question_id: questionDetails.question?._id,
      type: questionDetails.question?.type,
    };

    if (
      questionDetails.question?.type === questionTypes["mcq"] ||
      questionDetails.question?.type === questionTypes["text"]
    ) {
      // if answer is mcq or text
      data = { ...data, text: { key: 1, value: questionDetails.answer } };
    } else if (
      // if answer is range or number
      questionDetails.question?.type === questionTypes["range"] ||
      questionDetails.question?.type === questionTypes["number"]
    ) {
      // finalAnswer = { questionDetails.answer };
      data = { ...data, number: questionDetails.answer };
    } else if (questionDetails.question?.type === questionTypes["checkbox"] ||
      questionDetails.question?.type === questionTypes["multipleRange"]) {
      // if answer is checkbox
      data = { ...data, text: questionDetails?.answer };
    }

    if (questionDetails.question?.hasDate) {
      data = { ...data, month: month[new Date().getMonth()], year: new Date().getFullYear() };
    }

    // setQuestNumber((prev) => prev + 1);
    // let executeApi = () => { };
    // if (questionDetails?.answeredBefore) {
    //   executeApi = updateAnswer;
    // } else {
    //   executeApi = submitAnswer;
    // }

    submitAnswer(data)
      .then((data) => {
        console.log("🚀 ~ handleNext ~ data", data);
        if (questionDetails.questNumber === totalQuestions) {
          console.log("Survey completed");
          setQuestionDetails({
            ...questionDetails,
            surveyCompleted: true,
            question: null,
          });
          setLoading(false);
        } else getQuestion(1, true);
        // setQuestNumber((prev) => prev + 1);
      })
      .catch((error) => {
        setLoading(false);
        console.error("🚀 ~ handleNext ~ error", error);
        toast.error("Error submitting answer. Please try again.");
      });
    // } else {
    //   // Submit api
    //   console.log("Submit API");
    // }
  };

  const handlePrevious = () => {
    if (!loading) setLoading(true);

    getQuestion(-1, true);
  };

  const handleEditAnswers = () => {
    if (!loading) setLoading(true);

    setQuestionDetails({
      ...questionDetails,
      surveyCompleted: false,
      questNumber: 1,
      question: null,
      answer: "",
      answeredBefore: false,
    });
    getQuestion(0, false);
  };

  return (
    <div className="max-w-3xl mx-auto w-full px-4 py-6 md:py-8">
      {/* Progress Header */}
      {!questionDetails?.surveyCompleted && (
        <div className="mb-6 md:mb-8">
          <h1 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
            Farm Assessment Questionnaire
          </h1>
          <div className="bg-white rounded-lg p-3 md:p-4 shadow-sm">
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs md:text-sm font-medium text-gray-600">Progress</span>
              <span className="text-xs md:text-sm font-medium text-gray-900">
                {`${questionDetails.questNumber}/${totalQuestions}`}
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-1.5 md:h-2">
              <div
                className="bg-darkGreen rounded-full h-1.5 md:h-2 transition-all duration-300"
                style={{ width: `${(questionDetails.questNumber / totalQuestions) * 100}%` }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Question Card */}
      <div className="bg-white rounded-xl shadow-sm p-4 md:p-6 mb-4 md:mb-6 overflow-hidden">
        {loading ? (
          <QuestionLoadingSkeleton />
        ) : questionDetails?.question?._id ? (
          <div className="space-y-4 md:space-y-6">
            <QuestionWrapper
              questionDetails={questionDetails}
              setQuestionDetails={setQuestionDetails}
            />
          </div>
        ) : (
          <div className="py-8 md:py-12">
            {questionDetails?.surveyCompleted ? (
              <div className="flex flex-col justify-center items-center">
                <Celebrations />
              </div>
            ) : (
              <div className="text-center text-gray-600">
                <p className="text-base md:text-lg font-medium">No questions available</p>
                <p className="text-xs md:text-sm mt-2">Please check back later</p>
              </div>
            )}
          </div>
        )}
      </div>

      {
        !loading && !questionDetails?.question?._id && questionDetails?.surveyCompleted && (
          <div className="bg-white rounded-xl shadow-sm p-6 md:p-8 mb-4 md:mb-6 overflow-hidden">
            <div className="text-center space-y-4">
              <h3 className="text-xl font-semibold text-gray-900">Survey Completed!</h3>
              <p className="text-gray-600">You can review and edit your answers if needed.</p>
              <div className="flex justify-center items-center">
                <button
                  className="inline-flex items-center px-6 py-3 rounded-lg bg-darkGreen hover:bg-opacity-90 transition-colors duration-200 text-white font-medium shadow-sm"
                  onClick={handleEditAnswers}
                >
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                  Edit My Answers
                </button>
              </div>
            </div>
          </div>
        )
      }



      {/* Navigation Buttons */}
      {!loading && questionDetails.question?._id && (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 md:gap-4 h-[38px]">
          <div className="flex items-center gap-2">
            {questionDetails.answeredBefore && (
              <Tick width={20} height={20} color={appColors.primaryGreen} />
            )}
            <span className="text-xs md:text-sm text-gray-600 relative">
              {/* Input for question number */}
              Question <input
                type="number"
                value={questionDetails.questNumber}
                // onFocus={() => setShowMessage(true)} // Show message on focus
                // onBlur={() => setShowMessage(false)} // Hide message on blur
                onChange={(e) => {
                  const newQuestNumber = Number(e.target.value);
                  setInputChanged(true);
                  if (newQuestNumber >= 0 && newQuestNumber <= totalQuestions) {
                    setQuestionDetails({ ...questionDetails, questNumber: newQuestNumber });
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    if (!loading) setLoading(true);
                    getQuestion(questionDetails.questNumber, false);
                  }
                }}
                className="px-1 h-6 text-center border border-gray-300 rounded [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none group/showMessage peer !max-w-7"
                // min={}
                max={totalQuestions}
              /> of {totalQuestions}
              {<p className="absolute text-xs text-gray-500 md:top-[29px] md:right-0 md:left-0 right-10 hidden peer-focus:block min-w-44 left-[112px] top-1">(Enter to update the question.)</p>} {/* Message displayed when focused */}
            </span>
          </div>

          {!inputChanged && <div className="flex gap-2 md:gap-3 w-full md:w-auto">
            {questionDetails?.questNumber > 1 && (
              <button
                onClick={handlePrevious}
                className="flex-1 md:flex-none px-3 md:px-4 py-2 text-xs md:text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-darkGreen block"
              >
                Previous
              </button>
            )}

            <button
              onClick={handleNext}
              disabled={questionDetails.answer === 0 || questionDetails.answer === '0' ? false : !questionDetails.answer}
              className={`flex-1 md:flex-none px-3 md:px-4 py-2 text-xs md:text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-darkGreen ${(questionDetails.answer === 0 || questionDetails.answer === '0' ? false : !questionDetails.answer)
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-darkGreen hover:bg-opacity-90"
                }`}
            >
              {questionDetails.questNumber >= totalQuestions ? "Submit" : "Next"}
            </button>
          </div>}
        </div>
      )}
    </div>
  );
};

export default Questionaire;
